import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, memo, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { DisabledTableServiceCivilStatusMenu } from 'shell/view-models/disabled-menu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface ServiceTableCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: DisabledTableServiceCivilStatusMenu;
}

const ServiceTableCollapseComponent = ({
  onSubItemClick,
  link,
  active,
}: ServiceTableCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  return (
    <Fragment>
      <ListItem
        button
        key="Tabelle di servizio"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Tabelle di servizio" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {active.stamp ? (
            <Link key={`${link}/timbri`} to={`${link}/timbri`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText
                  className={classes.colorItems}
                  primary="Timbri e diciture certificati"
                />
              </ListItem>
            </Link>
          ) : undefined}
          {active.annotation ? (
            <Link key={`${link}/annotazioni`} to={`${link}/annotazioni`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Testo annotazioni" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.registry ? (
            <Link key={`${link}/registri`} to={`${link}/registri`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Registri" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.serie ? (
            <Link key={`${link}/serie`} to={`${link}/serie`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText
                  className={classes.colorItems}
                  primary="Transcodifica Serie Content Manager"
                />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

ServiceTableCollapseComponent.displayName = 'Servive Table Collapse Item';

const ServiceTableCollapse = memo(ServiceTableCollapseComponent);

export default ServiceTableCollapse;
